export default [
  {
    path: '/organization',
    component: () => import('@/views/pages/organization/index.vue'),
    redirect: '/organization/member',
    children: [
      {
        path: 'organization',
        name: 'organization',
        meta: { title: "成员管理" },
        component: () => import('@/views/pages/organization/organization/index.vue')
      },
      {
        path: 'docs',
        name: 'docs',
        meta: { title: "资料下载" },
        component: () => import('@/views/pages/organization/docs.vue')
      },
      {
        path: 'college',
        name: 'college',
        meta: { title: "信奥学院" },
        component: () => import('@/views/pages/organization/college.vue')
      },
      {
        path: 'member',
        name: 'member',
        meta: { title: "成员管理" },
        component: () => import('@/views/pages/organization/member/index.vue')
      },
      {
        path: 'course',
        name: 'course',
        meta: { title: "课程列表" },
        component: () => import('@/views/pages/organization/course/index.vue')
      },
      {
        path: 'class',
        name: 'class',
        meta: { title: "班级管理" },
        component: () => import('@/views/pages/organization/class/index.vue')
      },
      {
        path: 'group',
        name: 'group',
        meta: { title: "课程列表" },
        component: () => import('@/views/pages/organization/group/index.vue')
      },
      {
        path: 'problem-list',
        name: 'problem-list',
        meta: { title: "班级管理" },
        component: () => import('@/views/pages/organization/problem_list/index.vue')
      },
      {
        path: 'contest',
        name: 'contest',
        meta: { title: "比赛管理" },
        component: () => import('@/views/pages/organization/contest/index.vue')
      },
      {
        path: 'wiki',
        name: 'wiki',
        meta: { title: "系统通知" },
        component: () => import('@/views/pages/organization/wiki.vue')
      },
      {
        path: 'setting',
        name: 'organizationSetting',
        meta: { title: "课程设置" },
        component: () => import('@/views/pages/organization/setting/index.vue')
      }
    ]
  }
]
